import Header from './Header/Header.js'
import Home from './pages/Home.js'
import About from './pages/About.js'
import Detail from './pages/Detail.js'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

function App() {
  return (
    <div>
      <div className="container-fluid">
        <div className="d-flex justify-content-center">
          <div className="app-frame">
            <Header />
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="d-flex justify-content-center">
          <div className="app-frame">
            <Router>
              <Routes>
                <Route path="/" element={<Home /> } />
                <Route path="/About" element={<About /> } />
                <Route path="/Detail/:str" element={<Detail /> } />
              </Routes>
            </Router>
          </div>
        </div>
      </div>
    </div>
  )

}

export default App
